import { render, staticRenderFns } from "./lq006a.vue?vue&type=template&id=88306cc2"
import script from "./lq006a.vue?vue&type=script&lang=js"
export * from "./lq006a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports